import { useState, type FC } from 'react';
import { X } from 'lucide-react';

type CorporateOrderInfoProps = {
  hidden?: boolean;
};

const CorporateOrderInfo: FC<CorporateOrderInfoProps> = ({ hidden = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (hidden) return null;

  const stopControlEventPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <div
      className="fixed left-4 bottom-4 z-[20] md:absolute md:left-8 md:bottom-8"
      data-seatmap-control="corporate-order-info"
      onClick={stopControlEventPropagation}
      onPointerDown={stopControlEventPropagation}
      onPointerUp={stopControlEventPropagation}
    >
      {isOpen ? (
        <div className="absolute bottom-[64px] left-0 w-[260px] max-w-[calc(100vw-40px)] rounded-lg bg-surface-card px-5 py-4 text-sm leading-5 text-text-primary shadow-[var(--shadow-xl)]">
          Для корпоративных заказов пишите на{' '}
          <a
            href="mailto:sales@navka.show"
            className="font-medium text-text-link hover:text-text-link-hover"
          >
            sales@navka.show
          </a>
        </div>
      ) : null}

      <button
        type="button"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-surface-card text-xl font-semibold text-action-primary shadow-[var(--shadow-lg)] transition-all hover:bg-action-ghost-hover hover:scale-105 active:scale-95"
        aria-label={
          isOpen
            ? 'Скрыть информацию для корпоративных заказов'
            : 'Информация для корпоративных заказов'
        }
        aria-expanded={isOpen}
        onClick={() => setIsOpen(current => !current)}
      >
        {isOpen ? <X className="h-5 w-5 text-text-primary" aria-hidden="true" /> : 'i'}
      </button>
    </div>
  );
};

export default CorporateOrderInfo;
